const config = {
    url:{
        Local:'http://localhost:8080/api',
        Development: 'https://conarteinternacionalserver-b9e22515bae2.herokuapp.com/api',
        Production:'https://conarteinternacionalserver-b9e22515bae2.herokuapp.com/api'
    }
}

export default config 